/**
 * @title 嘉宾登录页面接口
 * @date 2020-11-24
 */
export class IGetMeeting {
  m: string = "";
}
export class IGetMeetingCode {
  m: string = "";
  phone?: string = "";
}
export class IGetMeetingLogin {
  m: string = "";
  phone?: string = "";
  code?: string = "";
}